import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
    ISectionConfiguration,
    WizardStateAbout,
} from 'src/features/common/universe-wizard/context/wizard-context.types';
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { Button } from 'src/ui/common/atoms/button';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';
import { getUrlWithPublicStorage } from 'src/utils/get-url-with-public-host';
import {
    StyledAboutUniverse,
    StyledDescription,
    StyledSpan,
    StyledText,
    StyledTextWrapper,
} from './about-universe.styles';

export const AboutUniverse: React.FC<ISectionConfiguration<WizardStateAbout>> = (props) => {
    const { previewImage, title, description, previewImageEnabled } = props;
    const { t } = useTranslation(['pages']);
    const screen = useScreenDetect();
    const router = useRouter();
    const { scrollTo } = router.query;
    const isQueryEmpty = Object.keys(router.query).length === 0;

    useEffect(() => {
        if (!isQueryEmpty && scrollTo === 'about-us') {
            document.querySelector('[data-component-id="about-us"]')?.scrollIntoView();
        }
    }, []);

    return (
        <StyledAboutUniverse padding="0 0 80px" data-component-id="about-us" id="about-us">
            <StyledTextWrapper>
                <StyledText>
                    <Typography variant="title" color="white" sizeLg="lg" sizeSm="md">
                        Brug
                        <StyledSpan>#thefreudianslip</StyledSpan>
                        på Instagram og deltag i en konkurrence om 2 billetter til Paris.
                    </Typography>
                </StyledText>
            </StyledTextWrapper>

            <Grid xs={1} sm={previewImage && previewImageEnabled ? 2 : 1}>
                {previewImage && previewImageEnabled && (
                    <Spacing mb="40px" mbSm="0" mrSm="24px" mrMd="64px">
                        <img src={getUrlWithPublicStorage(previewImage)} alt="whitelabel preview" />
                    </Spacing>
                )}
                <FlexBox flexDirection="column">
                    <Spacing mb="24px" mbMd="32px" pt="0" ptMd="24px">
                        <Typography variant="title" color="gs200" size={screen.xs || screen.sm ? 'xs' : 'sm'} uppercase>
                            {title || t('home.universeAbout.title')}
                        </Typography>
                    </Spacing>
                    <Spacing mb="30px" mbMd="56px">
                        <Typography variant="title" size={screen.xs || screen.sm ? 'base' : 'md'} color="white">
                            <StyledDescription dangerouslySetInnerHTML={{ __html: description ?? '' }} />
                        </Typography>
                        <br />
                        <Typography variant="title" size={screen.xs || screen.sm ? 'base' : 'md'} color="white">
                            Ulven er elskeren i både den fysiske og filosofiske forstand af ordet. Sammenholdt med hans
                            voldsomme uafhængighed - er dette indianske dyresymbol lidt af en selvmodsigelse. At have
                            brug for hans frihed, men stadig være ret blid og medfølende – giver billedet af "den
                            ensomme ulv".
                        </Typography>
                        <br />
                        <Typography variant="title" size={screen.xs || screen.sm ? 'base' : 'md'} color="white">
                            Fotografen bag den unikke billedkunst er Sebastian Falck Stigsby.
                        </Typography>
                    </Spacing>
                    <Link href="https://discord.gg/wxMqPyAUvY" prefetch={false}>
                        <a target="_blank">
                            <Button variant="outline" stretch={screen.xs || screen.sm}>
                                Tilmeld dig Discord
                            </Button>
                        </a>
                    </Link>
                </FlexBox>
            </Grid>
        </StyledAboutUniverse>
    );
};
